/* MONT DEGRÉS v1 — guide des tailles (sections/md-guide-tailles.liquid), 02/11/2026. Vanilla, sans dépendance, rien n'est envoyé.
   Règle des fiches copiée de md-vet.js (rang) : première ligne dont le maximum atteint la valeur ; la plus grande des deux tailles l'emporte.
   Sans script : tableaux complets, cartes repliables natives. */
(()=>{
'use strict';
if(window.__mdGuide)return;window.__mdGuide=1;
const $=(s,r=document)=>r.querySelector(s), $$=(s,r=document)=>[...r.querySelectorAll(s)];
function start(){
  const src=$('#mdg-grilles');if(!src)return;
  let GR={};try{GR=JSON.parse(src.textContent);}catch(e){return;}
  const rang=(g,v,k)=>g.findIndex(r=>v<=r[k]);
  const virg=n=>String(n).replace('.',',');
  const surligner=(k,t)=>$$('.mdg-tab[data-k="'+k+'"] tbody tr').forEach(r=>r.classList.toggle('on',r.dataset.t===t));
  const voir=k=>$('#mod-'+k)?' <a href="#mod-'+k+'" data-ouvre="'+k+'">Voir le tableau</a>':'';
  document.addEventListener('click',e=>{const a=e.target.closest&&e.target.closest('[data-ouvre]');if(!a)return;const m=$('#mod-'+a.dataset.ouvre);if(m)m.open=true;});

  /* Sélecteur vestes, gilets, sweats */
  const sel=$('#mdg-modele'),hI=$('#mdg-h'),pI=$('#mdg-p'),qI=$('#mdg-q'),res=$('#mdg-res'),fHP=$('#mdg-champsHP'),fQ=$('#mdg-champQ');
  if(sel&&sel.value){
    const calc=()=>{
      const k=sel.value,G=GR[k],g=G.g;res.textContent='';$$('.mdg-tab tr.on').forEach(r=>r.classList.remove('on'));
      if(G.mode==='none'){res.innerHTML='<span>'+G.nom+'&nbsp;: tailles '+G.tailles+', sans mesures du fabricant. Entre deux tailles, prenez au-dessus, ou <a href="#mdg-contact">écrivez-nous</a>.</span>';return;}
      if(G.mode==='q'){
        const q=parseFloat(String(qI.value).replace(',','.'));if(!(q>=40&&q<=80))return;
        const i=rang(g,q,'q');
        if(i<0){res.innerHTML='<span>Au-delà du '+g[g.length-1].t+'&nbsp;: <a href="#mdg-contact">écrivez-nous</a>, réponse sous 24&nbsp;h ouvrées.</span>';return;}
        surligner(k,g[i].t);res.innerHTML='<span>'+G.nom+'&nbsp;: taille conseillée <b>'+g[i].t+'</b>.'+voir(k)+'</span>';return;
      }
      const h=parseFloat(hI.value),p=parseFloat(pI.value);if(!(h>=140&&h<=215)||!(p>=40&&p<=160))return;
      const a=rang(g,h,'h'),b=rang(g,p,'p');
      if(a<0||b<0){res.innerHTML='<span>'+G.nom+'&nbsp;: au-delà du '+g[g.length-1].t+'. <a href="#mdg-contact">Écrivez-nous</a>, réponse sous 24&nbsp;h ouvrées.</span>';return;}
      const r=g[Math.max(a,b)];surligner(k,r.t);
      const rep=r.c?'<small>Le '+r.t+' mesure '+r.c+'&nbsp;cm de tour de poitrine, soit '+virg(r.c/2)+'&nbsp;cm d’une aisselle à l’autre à plat&nbsp;: comparez avec une veste à vous.</small>':'';
      res.innerHTML='<span>'+G.nom+'&nbsp;: prenez du <b>'+r.t+'</b>.'+voir(k)+'</span>'+rep;
    };
    const champs=()=>{const m=GR[sel.value].mode;fHP.hidden=(m!=='hp');fQ.hidden=(m!=='q');calc();};
    sel.addEventListener('change',champs);[hI,pI,qI].forEach(i=>i.addEventListener('input',calc));
    champs();
  }

  /* Gants : tour de main */
  const tI=$('#mdg-tour'),tRes=$('#mdg-tourRes');
  if(tI&&GR.u3){
    const U=GR.u3.g;
    tI.addEventListener('input',()=>{
      const v=parseFloat(String(tI.value).replace(',','.'));tRes.textContent='';surligner('u3','');if(!(v>=12&&v<=40))return;
      const i=rang(U,v,'tour');
      if(i<0){tRes.innerHTML='<span>Au-delà du '+U[U.length-1].t+'&nbsp;: <a href="#mdg-contact">écrivez-nous</a>.</span>';return;}
      surligner('u3',U[i].t);tRes.innerHTML='<span>Urban 3&nbsp;: prenez du <b>'+U[i].t+'</b>.</span>';
    });
  }

  /* Enfants : sa taille d'abord, son âge sinon */
  const eH=$('#mdg-eh'),eA=$('#mdg-ea'),eRes=$('#mdg-eRes');
  if(eH&&GR.enf){
    const E=GR.enf.g;
    const calcE=()=>{
      const h=parseFloat(eH.value),a=parseFloat(eA.value);eRes.textContent='';surligner('enf','');
      if(h>=90&&h<=190){
        if(h<E[0].hm){eRes.innerHTML='<span>Nos tailles commencent à '+E[0].hm+'&nbsp;cm.</span>';return;}
        const i=rang(E,h,'h');if(i<0){eRes.innerHTML='<span>Au-delà de '+E[E.length-1].h+'&nbsp;cm, passez aux tailles adultes.</span>';return;}
        surligner('enf',E[i].t);eRes.innerHTML='<span>Taille conseillée&nbsp;: <b>'+E[i].t+'</b>.</span>';return;
      }
      if(a>=3&&a<=17){
        const j=rang(E,a,'a');if(j<0){eRes.innerHTML='<span>Au-delà de '+E[E.length-1].a+'&nbsp;ans, mesurez l’enfant&nbsp;: une taille adulte ira peut-être mieux.</span>';return;}
        surligner('enf',E[j].t);eRes.innerHTML='<span>Taille indicative pour son âge&nbsp;: <b>'+E[j].t+'</b>. Sa taille en cm compte plus.</span>';
      }
    };
    eH.addEventListener('input',calcE);eA.addEventListener('input',calcE);
  }

  /* Puce active */
  const chips=$$('.mdg-chips a'),secs=chips.map(a=>$(a.getAttribute('href'))).filter(Boolean);
  if('IntersectionObserver' in window){
    const vis={};
    const io=new IntersectionObserver(es=>{
      es.forEach(e=>{vis[e.target.id]=e.isIntersecting;});
      const on=secs.filter(s=>vis[s.id])[0];
      chips.forEach(a=>a.classList.toggle('on',!!on&&a.getAttribute('href')==='#'+on.id));
      const ch=$('.mdg-chips a.on'),ul=$('.mdg-chips ul');
      if(ch&&ul)ul.scrollLeft=Math.max(0,ch.offsetLeft-ul.offsetLeft-20);
    },{rootMargin:'-80px 0px -60% 0px'});
    secs.forEach(s=>io.observe(s));
  }

  /* Copier l'adresse */
  $$('.mdg [data-copie]').forEach(b=>b.addEventListener('click',()=>{
    const ok=()=>{b.textContent='Copié';setTimeout(()=>{b.textContent='Copier';},1600);};
    try{navigator.clipboard.writeText(b.dataset.copie).then(ok,ok);}catch(e){ok();}
  }));
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();
